var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeopleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 22,
    viewBox: "0 0 39 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3305",
    "data-name": "Group 3305",
    transform: "translate(-506.001 -543)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_443",
    "data-name": "Group 443",
    transform: "translate(530.943 553.176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_442",
    "data-name": "Group 442"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M348.189,257.225h-2.557a7.4,7.4,0,0,0-4.052,1.2,9.965,9.965,0,0,1,4.487,8.317v1.084h9.571v-3.154A7.458,7.458,0,0,0,348.189,257.225Z",
    transform: "translate(-341.58 -257.225)",
    fill: "#fefefe"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_445",
    "data-name": "Group 445",
    transform: "translate(506.001 553.176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_444",
    "data-name": "Group 444"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M10.006,257.225H7.449A7.458,7.458,0,0,0,0,264.674v3.154H9.7v-1.084a9.97,9.97,0,0,1,4.425-8.275A7.4,7.4,0,0,0,10.006,257.225Z",
    transform: "translate(0 -257.225)",
    fill: "#fefefe"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_447",
    "data-name": "Group 447",
    transform: "translate(531.253 543.822)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_446",
    "data-name": "Group 446"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M350.353,121.416h-.04A5.3,5.3,0,0,0,350.361,132h.04a4.86,4.86,0,0,0,3.567-1.61,5.413,5.413,0,0,0,1.41-3.723A5.17,5.17,0,0,0,350.353,121.416Z",
    transform: "translate(-345.337 -121.416)",
    fill: "#fefefe"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_449",
    "data-name": "Group 449",
    transform: "translate(509.707 543.822)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_448",
    "data-name": "Group 448"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M49.954,121.416h-.04A5.3,5.3,0,0,0,49.962,132H50a4.86,4.86,0,0,0,3.567-1.61,5.412,5.412,0,0,0,1.41-3.723A5.17,5.17,0,0,0,49.954,121.416Z",
    transform: "translate(-44.938 -121.416)",
    fill: "#fefefe"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_451",
    "data-name": "Group 451",
    transform: "translate(519.77 543)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_450",
    "data-name": "Group 450"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M192.388,111.445a5.964,5.964,0,0,0-5.788,6.115,6.154,6.154,0,0,0,3.314,5.527,5.5,5.5,0,0,0,4.948,0,6.154,6.154,0,0,0,3.314-5.527A5.964,5.964,0,0,0,192.388,111.445Z",
    transform: "translate(-186.6 -111.445)",
    fill: "#fefefe"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_441",
    "data-name": "Group 441",
    transform: "translate(516.546 555.224)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_440",
    "data-name": "Group 440"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M161.661,282.954a7.432,7.432,0,0,0-3.574-.909h-3.076a7.47,7.47,0,0,0-7.471,7.471v2.3h18.018v-2.3A7.469,7.469,0,0,0,161.661,282.954Z",
    transform: "translate(-147.54 -282.045)",
    fill: "#fefefe"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleIcon);
export default __webpack_public_path__ + "static/media/PeopleIcon.d5c0894f2fa8ec34a734e4c4d153c995.svg";
export { ForwardRef as ReactComponent };